import gql from 'graphql-tag';

import {
  AvatarPhoto,
  UserDetails,
} from '../../../../graphql/fragments/account';
import { PhotoUrlTypeFields } from '../../../consumer/graphql/fragments/global';

export const VideoDetails = gql`
  fragment VideoDetails on Video {
    id
    name
    description
    width
    height
    duration
    embed_url
    created_at
    thumbnails {
      url
      width
      height
    }
    download_enabled
    type
    account {
      id
      ...UserDetails
      ...AvatarPhoto
    }
    contributor_account {
      id
      ...UserDetails
      ...AvatarPhoto
    }
    attribution {
      name
      username
      organization_name
      avatar_photo {
        id
        thumbnail_urls {
          ...PhotoUrlTypeFields
        }
      }
      account_id
      photo_attribution_page {
        is_enabled
      }
    }
  }
  ${UserDetails}
  ${AvatarPhoto}
  ${PhotoUrlTypeFields}
`;
